<div [style.height.px]="height" class="d-flex justify-content-center align-items-center">
  <div class="thumbnail-preview-container" [style.max-height.px]="height">
    <img
      [style.max-height.px]="height"
      [style.height.px]="objectFitCover ? height : null"
      [style.objectFit]="objectFitCover ? 'cover' : 'initial'"
      [style.border-radius.px]="borderRadius"
      [ngStyle]="width && { 'width': width + 'px', 'min-width': width + 'px' }"
      [src]="previewLink"
      (error)="isImgLoadingError = true"
      class="preview-img"
      [hidden]="!hasPreview"
      alt="No image"/>
    <i [hidden]="hasPreview"
       class="icon-iris fa-3x preview-img"
       [ngClass]="fileIcon"
       [ngStyle]="iconSize && { 'font-size': iconSize + 'px' }"></i>

    <div class="preview-img-buttons">
      <sk-button size="sm"
                 data-test="file-preview-downloadFile-button"
                 appearance="icon"
                 [hidden]="!showDownload"
                 (click)="downloadFile()"
                 [matTooltip]="'label.Download' | translate">
        <ng-template buttonPrefix>
          <i class="icon fa fa-download"></i>
        </ng-template>
      </sk-button>
      <sk-button size="sm"
                 data-test="file-preview-show-button"
                 appearance="icon"
                 [hidden]="!showPreview || isOfficeEditableDocument"
                 (click)="showFilePreviewModal()"
                 [matTooltip]="'label.Preview' | translate"
                 [ngStyle]="!showDownload && {'padding-left': '16px'}"
                 clickStopPropagation>
        <ng-template buttonPrefix>
          <i class="icon fa fa-eye"></i>
        </ng-template>
      </sk-button>

      @if (showEdit) {
        <sk-button size="sm"
                   data-test="file-preview-edit-button"
                   appearance="icon"
                   (click)="onEdit()"
                   [matTooltip]="'label.Edit' | translate">
          <ng-template buttonPrefix>
            <i class="icon fa fa-pencil"></i>
          </ng-template>
        </sk-button>
      }

      <sk-button size="sm"
                 appearance="icon"
                 data-test="file-preview-showOfficeEditModal-button"
                 [hidden]="!showPreview || !isOfficeEditableDocument"
                 (click)="showOfficeEditModal()"
                 [matTooltip]="'label.dms.OpenInMicrosoftOfficeOnline' | translate">
        <ng-template buttonPrefix>
          <i class="icon fa-fw fas fa-external-link-alt"></i>
        </ng-template>
      </sk-button>
    </div>
  </div>
</div>
